import { PropsWithoutRef } from 'react'

import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Segmented as AntdSegmented } from 'antd'
import { SegmentedProps } from 'antd/lib'
import { createStyles } from 'antd-style'

const useStyles = createStyles(({ prefixCls }) => ({
  segmented: {
    [`& .${prefixCls}-segmented-item`]: {
      flex: 1
    }
  }
}))

const Component = ({
  className,
  options = [],
  ...restProps
}: PropsWithoutRef<Partial<SegmentedProps>>) => {
  const { cx, styles } = useStyles()

  return (
    <AntdSegmented
      className={cx(styles.segmented, className)}
      options={options}
      {...restProps}
    />
  )
}

export const Segmented = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  }),
  mapProps({ dataSource: 'options' })
)
